import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, } from 'react';
import { useTranslation } from 'react-i18next';
import ToggleItem from '../ToggleItem';
import { useForm, usePage } from '@inertiajs/react';
import Notice from '../Notice';
import PersonalDetails from './PersonalDetails';
import Button from '../../atoms/Button';
import InputWrapper from '../../atoms/InputWrapper';
import Account from '../../atoms/icons/Account';
import { isSet } from 'lodash';
import useAuth from '../../hooks/useAuth';
import styled from 'styled-components';
const StyledToggleItem = styled(ToggleItem) `
    display: block;
`;
const UserInfo = ({ userInfo, emailDomain, disabled = false, }) => {
    const { t } = useTranslation();
    const { canRender } = useAuth();
    const page = usePage();
    const initialData = {
        is_deactivated: userInfo.is_deactivated,
        full_name: userInfo.name,
        email: userInfo.email,
    };
    const { data, setData, put, processing, errors, transform, } = useForm(initialData);
    const [notice, setNotice] = useState(null);
    transform((data) => ({
        ...data,
        email: data.email + '@' + emailDomain,
    }));
    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            put(window.location.href);
        }
        catch (e) {
            setNotice({
                type: 'error',
                title: t('notice.default_title'),
                text: t('notice.default_text'),
            });
        }
    };
    useEffect(() => {
        if (isSet(errors.is_deactivated)) {
            setNotice({
                type: 'error',
                title: t('notice.default_title'),
                text: t('notice.default_text'),
            });
        }
    }, [errors.is_deactivated]);
    return (_jsx(_Fragment, { children: _jsxs("form", { action: "./", method: 'put', onSubmit: handleSubmit, children: [notice && _jsx(Notice, { ...notice }), _jsx(InputWrapper, { children: _jsx(PersonalDetails, { data: data, setData: setData, errors: errors, emailDomain: userInfo.email_domain, disabled: processing || disabled, emailInputDisabled: emailDomain != userInfo.email_domain ||
                            userInfo.id == page.props.auth.user?.id }) }), canRender('user_suspend', _jsx(StyledToggleItem, { label: t('user.active_toggle'), checked: !data.is_deactivated, onValueChange: checked => setData('is_deactivated', checked), disabled: processing ||
                        disabled ||
                        userInfo.id == page.props.auth.user?.id })), _jsx(Button, { type: "submit", alignSelf: "flex-end", secondary: true, icon: _jsx(Account, {}), isLoading: processing, disabled: disabled, children: t('users.update_user_button') })] }) }));
};
export default UserInfo;
